export const state = {
    webhooksList: [],
    webhooksTotal: 0,
    webhook: {}
};
